import { GetServerSidePropsContext } from 'next';
import { IResponse, IPageData } from 'src/interface';
import PageService from 'src/services/PageService';
import ContentMoreSection from 'src/modules/content/components/sections/ContentMoreSection';

export function Publisher({
    resp,
    isMobile = true,
    isBot = false,
}: {
    resp: IResponse<IPageData<any>>;
    isMobile: boolean;
    isBot: boolean;
}) {
    const content = resp?.data?.content || ({} as any);
    return (
        <ContentMoreSection
            {...content}
            ContentItemProps={{
                lazyloadImage: !isBot,
            }}
            isMobile={isMobile}
            typeList="rank"
        />
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    return PageService.get(ctx, 'publisher', {
        id: ctx?.params?.id,
        page: ctx.params?.page || 1,
    });
}

export default Publisher;
